import { WebSocketReceiveWithSigningUserId } from './web-socket-receive-with-signing-user-id';
import type { Menu } from '../../../menu/dto/menu';

export class WebSocketReceiveReloadMenu extends WebSocketReceiveWithSigningUserId {
  override payload: {
    SigningUserId: string;
    MenuId: string;
    TemplateId: string;
    FileName: string;
  };

  isAboutThis(menu: Menu): boolean {
    if (!menu) return false;
    const theMenuChanged = menu?.id === this.payload?.MenuId;
    const theTemplateIAmCreatedFromChanged = menu?.templateId === this.payload?.TemplateId;
    return theMenuChanged || theTemplateIAmCreatedFromChanged;
  }

  getGroupingKey(): string {
    return `${this.payload?.SigningUserId}-${this.payload?.TemplateId || this.payload?.MenuId}`;
  }
}
